export const GRAPH_TYPES = [
  { id: 0, label: "Metric", value: "metric" },
  { id: 1, label: "Rate per mile", value: "rate_per_mile" },
  { id: 2, label: "Avg Line Haul Rate", value: "avg_line" },
  { id: 3, label: "Fuel Costs", value: "fuel_costs" }
];

export const RATE_TREND_EQUIPMENT = [
  { id: 0, label: "Any", value: "" },
  { id: 1, label: "Dry Van", value: "V, VC, VZ, WLK, VV" },
  { id: 2, label: "Reefer", value: "R, RZ" },
  { id: 3, label: "Flatbed", value: "F, FZ, MX, HS, LB, RGN, SD" }
];

export const RATE_TREND_EQUIPMENT_TYPES = [
  { id: 1, label: "Dry Van (V)", subLabel: "Dry Van", value: "V" },
  { id: 2, label: "Flatbed (F)", subLabel: "Flatbed", value: "F" },
  { id: 3, label: "Reefer (R)", subLabel: "Reefer", value: "R" },
  { id: 4, label: "Auto Carrier (AC)", subLabel: "Auto Carrier", value: "AC" },
  { id: 5, label: "B Train Flatbed (BT)", subLabel: "B Train Flatbed", value: "BT" },
  { id: 6, label: "Cargo Van (CV)", subLabel: "Cargo Van", value: "CV" },
  { id: 7, label: "Curtain Van (VC)", subLabel: "Curtain Van", value: "VC" },
  { id: 8, label: "Double Drop (DD)", subLabel: "Double Drop", value: "DD" },
  { id: 9, label: "Drayage (DR)", subLabel: "Drayage", value: "DR" },
  { id: 10, label: "Dump Trailer (DT)", subLabel: "Dump Trailer", value: "DT" },
  { id: 11, label: "Flatbed Hazmat (FZ)", subLabel: "Flatbed Hazmat", value: "FZ" },
  { id: 12, label: "Flatbed Maxi (MX)", subLabel: "Flatbed Maxi", value: "MX" },
  { id: 13, label: "Hopper Bottom (HB)", subLabel: "Hopper Bottom", value: "HB" },
  { id: 14, label: "Hot Shot (HS)", subLabel: "Hot Shot", value: "HS" },
  { id: 15, label: "Low Boy (LB)", subLabel: "Low Boy", value: "LB" },
  { id: 16, label: "Power Only (PO)", subLabel: "Power Only", value: "PO" },
  { id: 17, label: "Rail Container (RC)", subLabel: "Rail Container", value: "RC" },
  { id: 18, label: "Reefer Intermodal (RN)", subLabel: "Reefer Intermodal", value: "RN" },
  { id: 19, label: "Reefer Hazmat (RZ)", subLabel: "Reefer Hazmat", value: "RZ" },
  { id: 20, label: "RGN Flatbed (RGN)", subLabel: "RGN Flatbed", value: "RGN" },
  { id: 21, label: "Step Deck (SD)", subLabel: "Step Deck", value: "SD" },
  { id: 22, label: "Straight Truck (ST)", subLabel: "Straight Truck", value: "ST" },
  { id: 23, label: "Tanker (T)", subLabel: "Tanker", value: "T" },
  { id: 24, label: "Van Intermodal (VN)", subLabel: "Van Intermodal", value: "VN" },
  { id: 25, label: "Van HazMat (VZ)", subLabel: "Van HazMat", value: "VZ" },
  { id: 26, label: "Van Walking Floor (WLK)", subLabel: "Van Walking Floor", value: "WLK" },
  { id: 27, label: "Vented Van (VV)", subLabel: "Vented Van", value: "VV" },
  { id: 28, label: "Container", subLabel: "", value: "C" },
  { id: 29, label: "Other", subLabel: "Other", value: "2" }
];

export const RATE_TREND_COLORS = [
  {
    id: 0,
    color: "#3892B9"
  },
  {
    id: 1,
    color: "#F1CB93"
  },
  {
    id: 2,
    color: "#7D63C5"
  },
  {
    id: 3,
    color: "#F68300"
  },
  {
    id: 4,
    color: "#A2191F"
  },
  {
    id: 5,
    color: "#1E24BA"
  }
];
